import { DefineEntity, Entity2D, EntityType, Vector2 } from '../../../odie';
import { GameScene } from '../../GameScene';
import { BlockComponent } from '../../components/BlockComponent';
import { PositionComponent } from '../../components/PositionComponent';
import { BlockProps } from '../../defs/block';
import { BlockDef } from '../../defs/map';
import { _spawnBaseBlockEntity } from '../../entities/BlockEntity';
import { BarrelBlockComponent } from './BarrelBlockComponent';
import { BarrelBlockProps } from './BarrelBlock';

const BarrelBlockEntityDef = DefineEntity(
  Entity2D,
  PositionComponent,
  BlockComponent,
  BarrelBlockComponent,
);
export type BarrelBlockEntity = EntityType<typeof BarrelBlockEntityDef>;

export function _spawnBarrelBlockEntity(
  scene: GameScene,
  def: BlockDef,
  props: BlockProps,
  position: Vector2,
): BarrelBlockEntity {
  // spawn base block
  const entity = _spawnBaseBlockEntity(
    BarrelBlockEntityDef,
    scene,
    def.id,
    props,
    position,
    {
      blockBarrel: {
        props: props as BarrelBlockProps,
        option: def.option,
      },
    },
  );

  // build scene
  entity.c.view2d.view.addChild(entity.c.blockBarrel.view);

  return entity;
}
